import { Box, Text, Avatar } from '@chakra-ui/react';
import { useRelativeTime } from 'hooks/useRelativeTime';
import { PersonalNotification } from 'ui/types/PersonalNotification';
import gameTarget from 'ui/assets/images/game-target.png';
import gameRace from 'ui/assets/images/game-race.png';
import gameTournament from 'ui/assets/images/game-tournament.png';
import star from 'ui/assets/images/Star.png';
import tokens from 'ui/assets/images/Tokens.png';
interface NotificationItemProps {
  notification: PersonalNotification;
  onClick: (id: number, redirectLink: string) => void;
}
const AVATAR_MAP = {
  'game-sale-activity': gameTarget,
  'game-leaderboard-milestone': gameTournament,
  'game-updates-Incentive': gameTarget,
  'game-updates-Race': gameRace,
  'game-updates-Tournament': gameTournament,
  'incentive-game-started': gameTarget,
  'p2p-tokens': tokens,
  'p2p-tokens-private': tokens,
  'race-game-started': gameRace,
  'recognition-star': star,
  'tokens-awarded-private': tokens,
  'tokens-awarded-public': tokens,
  'tournament-game-started': gameTournament,
  'unspent-tokens': tokens
};
export const NotificationItem = ({
  notification,
  onClick
}: NotificationItemProps) => {
  const {
    content,
    createdAt,
    id,
    notificationType,
    relativeLink,
    readAt,
    sourceUser,
    title
  } = notification;
  const avatarImage = AVATAR_MAP[notificationType] || sourceUser?.profileImage || '/images/arcade_logo.png';
  return <Box _hover={{
    backgroundColor: 'cloud.200',
    cursor: 'pointer'
  }} onClick={() => onClick(id, relativeLink)} backgroundColor={readAt ? 'transparent' : 'cloud.100'} borderRadius={8} paddingX={2} paddingY={4} marginBottom={2} display="flex" alignItems="flex-start" data-sentry-element="Box" data-sentry-component="NotificationItem" data-sentry-source-file="NotificationItem.tsx">
      <Avatar src={avatarImage} size="md" data-sentry-element="Avatar" data-sentry-source-file="NotificationItem.tsx" />
      <Box data-sentry-element="Box" data-sentry-source-file="NotificationItem.tsx">
        <Text marginLeft={4} fontWeight="bold" fontFamily="codenext" fontSize="sm" color="cloud.800" data-sentry-element="Text" data-sentry-source-file="NotificationItem.tsx">
          {title || (!!sourceUser ? `${sourceUser?.name} Posted` : 'New Notification')}
        </Text>
        <Text marginBottom={1} marginLeft={4} fontSize="xs" color="text.secondary" fontWeight="400" data-sentry-element="Text" data-sentry-source-file="NotificationItem.tsx">
          {useRelativeTime(createdAt)}
        </Text>
        <Text marginLeft={4} fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="NotificationItem.tsx">
          {content}
        </Text>
      </Box>
    </Box>;
};